var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scale_input" }, [
    _c(
      "div",
      {
        ref: "areabox",
        staticClass: "area_box",
        style: { width: _vm.width + "px", height: _vm.height + "px" }
      },
      [
        _c("textarea", {
          ref: "area",
          attrs: { readonly: "" },
          domProps: { innerHTML: _vm._s(_vm.value) },
          on: { blur: _vm.blurText }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }